import * as React from "react";

import { makeStyles } from "@material-ui/styles";

import Tabs from "../../../../components/tab/Tabs";
import SubTab from "../../../../components/tab/SubTab";

import ReconciliationReportSummary from "./ReconciliationReportSummary";
import ReconciliationReportDetail from "./ReconciliationReportDetail";
import { isEmpty } from "../../../../utils/helpers";
import { useQuery } from "../../../../hooks";

const useStyles = makeStyles({
  root: {
    padding: "1em 1.5em"
  }
});

const ReconciliationReport = props => {
  const classes = useStyles();

  const routeParams = props.match?.params || {};
  const queryParams = new URLSearchParams(props.location.search);

  const orderId = !isEmpty(routeParams?.id) ? Number(routeParams.id) : null;
  const style = queryParams.get("style");
  const color = queryParams.get("color");

  const [tabIdx, setTabIdx] = React.useState(0);
  const [selectedKey, setSelectedKey] = React.useState(null);

  const { data: order = {} } = useQuery({ url: `orders/${orderId}`, params: { page: "cutPlan" } });
  const { data: reportSummaryList = [] } = useQuery(!isEmpty(orderId) && { url: `report-summary/by-order/${orderId}`, method: "get" });
  const { data: reportDetailList = [] } = useQuery(!isEmpty(orderId) && { url: `report-detail/by-order/${orderId}`, method: "get" });

  return (
    <div className={classes.root}>
      {/* Header */}
      <Tabs value={tabIdx} onChange={(e, idx) => setTabIdx(idx)}>
        <SubTab label="Summary" />
        <SubTab label="Detail" />
      </Tabs>

      <ReconciliationReportSummary
        order={order}
        style={style}
        color={color}
        reportSummaryList={reportSummaryList}
        reportDetailList={reportDetailList}
        tabIdx={tabIdx}
        selectedKey={selectedKey}
        setSelectedKey={setSelectedKey}
      />
      <ReconciliationReportDetail
        order={order}
        style={style}
        color={color}
        reportList={reportDetailList}
        tabIdx={tabIdx}
        selectedKey={selectedKey}
        setSelectedKey={setSelectedKey}
      />
    </div>
  );
};

export default ReconciliationReport;
